import { createAction } from 'redux-act';

export const logIn = createAction('Request to log in', (superVisor) => ({superVisor}));
export const logOut = createAction('Request to log out');
export const goToBreak = createAction('Request to go to break', (breakName) => ({breakName}));
export const leaveBreak = createAction('Request to leave break');
export const closeWorkItem = createAction('Request to close workItem', (workItemId, closureCode, notes) => ({ workItemId, closureCode, notes}));
export const moveToSupervisorBreak = createAction("closeSuperVisorBreakCard");